import { render, staticRenderFns } from "./grantPage.vue?vue&type=template&id=54ffc982&scoped=true&"
import script from "./grantPage.vue?vue&type=script&lang=js&"
export * from "./grantPage.vue?vue&type=script&lang=js&"
import style0 from "./grantPage.vue?vue&type=style&index=0&id=54ffc982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffc982",
  null
  
)

export default component.exports